export const ActivityLevels = {
    goodStanding: {
        label: 'Good Standing',
        value: 'good_standing',
    },
    delinquent10: {
        label: 'Action Required: Tablet Not in Use',
        value: 'delinquent_10',
    },
    delinquent20: {
        label: 'Delinquent - Action Required!',
        value: 'delinquent_20',
    },
    delinquent40: {
        label: 'Delinquent - Action Required!',
        value: 'delinquent_40',
    },
    delinquent60: {
        label: 'Action Required: Account Frozen',
        value: 'delinquent_60',
    },
    delinquent75: {
        label: '$150 Invoice Sent - Return Tablet Immediately to Cancel Invoice',
        value: 'delinquent_75',
    },
    delinquent75CA: {
        label: 'C$150 Invoice Sent - Return Tablet Immediately to Cancel Invoice',
        value: 'delinquent_75',
    },
    TIA: {
        label: 'Away',
        value: 'temporarily_inactive',
    },
    Swap: {
        label: 'Pending Tablet Swap',
        value: 'swap',
    },
    chargeRefunded: {
        label: 'Charge Refunded',
        value: 'charge_refunded',
    },
    chargeFailed: {
        label: '$150 Invoice Sent - Return Tablet Immediately to Cancel Invoice',
        value: 'charge_failed',
    },
    chargeFailedCA: {
        label: 'C$150 Invoice Sent - Return Tablet Immediately to Cancel Invoice',
        value: 'charge_failed',
    },
    chargeSuccessful: {
        label: 'Charge Successful',
        value: 'charge_successful',
    },
    MIA: {
        label: 'MIA - Not Charged',
        value: 'mia_not_charged',
    },
    invoiced: {
        label: 'Action Required: $150 Missing Tablet Invoice Due',
        value: 'invoiced',
    },
    invoicedCA: {
        label: 'Action Required: C$150 Missing Tablet Invoice Due',
        value: 'invoiced',
    },
    invoicedReturned: {
        label: 'Invoiced - Returned',
        value: 'invoiced_returned',
    },
    covid: {
        label: 'Account Paused (COVID-19)',
        value: 'covid',
    },
    delinquent60ActiveLine: {
        label: 'Action Required: Account Frozen',
        value: 'delinquent_60_line_active',
    },
    reapply: {
        label: 'Reactivation Pending',
        value: 'reapply',
    },
    invoicedTransit: {
        label: 'Tablet returned (in transit)',
        value: 'invoiced_transit',
    },
};

enum ActivityLevelsEnum {
    GOOD_STANDING = 'good_standing',
    DELINQUENT_10 = 'delinquent_10',
    DELINQUENT_20 = 'delinquent_20',
    DELINQUENT_40 = 'delinquent_40',
    DELINQUENT_60 = 'delinquent_60',
    DELINQUENT_75 = 'delinquent_75',
    TIA = 'temporarily_inactive',
    SWAP = 'swap',
    CHARGE_REFUNDED = 'charge_refunded',
    CHARGE_FAILED = 'charge_failed',
    CHARGE_SUCCESSFUL = 'charge_successful',
    MIA_NOT_CHARGED = 'mia_not_charged',
    INVOICED = 'invoiced',
    INVOICED_RETURNED = 'invoiced_returned',
    COVID = 'covid',
    REAPPLY = 'reapply',
    INVOICED_TRANSIT = 'invoiced_transit',
    LYFT_GOOD_STANDING = 'lyft_good_standing',
}
export { ActivityLevelsEnum };
